type Client = {
  clientId: number;
  clientName: string;
  costCenterName: string;
  sum: number;
}

type Document = {
  bucket: 'pretension';
  objectName: string;
  type: 'pretension' | 'attachment';
}

// Строка листа учёта в карточке претензии (задача 10833). Строка, которую миграция не свела
// с листом, приходит без sheetId — ссылки на лист у неё нет.
export type PretensionAccountingSheet = {
  sheetId?: number;
  number: string;
  periodFrom: string | null;
  periodTo: string | null;
  amount: number | null;
}

export type PretensionType = 'damage' | 'fine' | '';

export interface PretensionStatusHistoryRow {
  fromStatus: string | null;
  toStatus: string;
  changedAt: string;
  changedBy: string | null;
  comment: string | null;
}

export interface Pretension {
  id: number;
  sequence: string;
  type: PretensionType;
  dateFrom: string;
  dateTo: string;
  postDate: string;
  platformName: string;
  supplierLegalName: string;
  status: PretensionStatus;
  clients: Client[];
  documents: Document[];
  // Ключа нет, если у претензии нет строк листов.
  accountingSheets?: PretensionAccountingSheet[];
  typeName?: string;
  comment: string | null;
  // BC2.1' (FML-svpt): поля статуса отправки в 1С ERP.
  // Заполняются после успешного publish в ActiveMQ от send-pretension-to-erp
  // (UPDATE из pretensions PHP /pretension-update-sent-to-erp-at).
  sentToErpAt?: string | null;
  erpMessageId?: string | null;
  // §6.4: производный от истории набор пройденных resume-целей (вычисляет PHP через
  // ResumeStageGuard). Фронт рендерит resume-кнопки ровно по нему; историю сам не деривит.
  // Подмножество {control_await, signer_signing_await, supplier_approve_await, accounting_approve_await}.
  resumableStages?: string[];
  // 11991: история статусов, старые строки первыми. Поставщику коннектор ключ не отдаёт.
  statusHistory?: PretensionStatusHistoryRow[];
}

export enum PretensionStatus {
  // draft-as-status (Вариант B): черновик — первый статус претензии (jBPM не запущен).
  DRAFT = 'draft',
  // soft-delete черновика; server-side исключается из списков (оборонительно для humanize).
  DRAFT_DISCARDED = 'draft_discarded',
  CREATED = 'created',
  CONTROL_AWAIT = 'control_await',
  SIGNER_SIGNING_AWAIT = 'signer_signing_await',
  // T4 (FML-wsj2.3): промежуточный статус во время вызова Diadoc.
  // Value совпадает с PHP-константой signer_signing_in_progress из T1.
  SIGNER_SIGNING_IN_PROGRESS = 'signer_signing_in_progress',
  // §5: статус цепочки DSS-подписи (есть в ru.json/бэке, но отсутствовал в enum). Нужен для §9 cancel.
  DIADOC_SIGNING_AWAIT = 'diadoc_signing_await',
  // CS-E: value 'supplier_approve_await' — canonical legacy (backend/BPMN).
  // Enum-ключ использует SIGNING_AWAIT для domain consistency на фронте.
  SUPPLIER_SIGNING_AWAIT = 'supplier_approve_await',
  ACCOUNTING_APPROVE_AWAIT = 'accounting_approve_await',
  PAYMENT_DONE = 'payment_done',
  PROBLEM = 'problem',
  RECALLED = 'recalled',
}
